import { render, staticRenderFns } from "./ImgSwiperV4.vue?vue&type=template&id=74a5ae0b&scoped=true&"
import script from "./ImgSwiperV4.vue?vue&type=script&lang=js&"
export * from "./ImgSwiperV4.vue?vue&type=script&lang=js&"
import style0 from "./ImgSwiperV4.vue?vue&type=style&index=0&id=74a5ae0b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a5ae0b",
  null
  
)

export default component.exports